import LabelPositionController from "../../output/labels/labels/label-position-controller.js";

class DomLabelPositionController {
    setPosition(label, x, y) {
        label.domElement.style.left = x !== undefined ? (x*100)+"%" : "";
        label.domElement.style.top = y !== undefined ? (y*100)+"%" : "";
    }
}

export default DomLabelPositionController;
